/**
 * sentry.ts — initialisation Sentry pour le frontend React.
 *
 * Appelez `initSentry()` au tout début de main.tsx, avant le rendu React.
 * Si VITE_SENTRY_DSN est absent (dev local), Sentry reste silencieux.
 */
import * as Sentry from '@sentry/react';

export const initSentry = (): void => {
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,

    integrations: [
      // Suivi des navigations / changements de route
      Sentry.browserTracingIntegration(),
      // Session Replay : enregistre un extrait autour de chaque erreur
      Sentry.replayIntegration({
        maskAllText:   false,
        blockAllMedia: false,
      }),
    ],

    // Traces de performance : 10 % en prod, 100 % en staging/dev
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,

    // Replay : 5 % des sessions, 100 % des sessions avec erreur
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 1.0,

    // Ne pas envoyer les données PII automatiquement
    sendDefaultPii: false,
  });
};

/** Reporte manuellement une exception (utile dans les catch globaux). */
export const captureException = Sentry.captureException;

/** Ajoute du contexte utilisateur après authentification. */
export const setSentryUser = (user: { id: string; email?: string } | null): void => {
  if (user) {
    Sentry.setUser({ id: user.id, email: user.email });
  } else {
    Sentry.setUser(null);
  }
};
